import './style.css';

import { bind } from 'bind-decorator';
import React from 'react';
import QuickPickContainer from '../container';
import { getNestedLookUpObjectKeysByPosition, onSelectHandler } from '../quick-pick-helper.ts';
import OtherItem from './controls/other-item';
import Item from './controls/quick-pick-item';

class QuickPickRaw extends React.Component {
  static defaultProps = {
    selected: 'main',

    onChange: () => {},
    onNavigate: () => {}
  };

  constructor(props, context) {
    super(props, context);

    this.state = { transition: 'slide-right' };
  }

  UNSAFE_componentWillReceiveProps(n) {
    let { selected } = this.props;
    if (n.selected === selected) {
      return;
    }
    let transition = n.selected.length > selected.length ? 'slide-left' : 'slide-right';
    this.setState({ transition: transition });
  }

  render() {
    let { menu, selected, other, onChange } = this.props;

    menu = !!menu.toJS ? menu.toJS() : menu;
    menu = Object.prototype.toString.call(menu) !== '[object Array]' ? menu[selected] : menu;

    let keys = getNestedLookUpObjectKeysByPosition(menu);

    const quickPicks = keys.map((key, i) => {
      return (
        <Item
          key={i}
          selected={menu}
          selectedKey={key}
          menu={this.props.menu}
          tabIndex={i}
          onClick={this.onSelect}
        />
      );
    });

    //Other option should only be displayed on the main list and not for sub list
    let otherItem;
    if (other && selected === 'main') {
      otherItem = <OtherItem index={keys.length} onClick={onChange} />;
    }

    return (
      <QuickPickContainer {...this.props} {...this.state} onBack={this.onBack}>
        <div key={selected} className="content" tabIndex={0}>
          {quickPicks}
          {otherItem}
        </div>
      </QuickPickContainer>
    );
  }

  @bind
  onSelect(key, text, e) {
    onSelectHandler(key, text, e, this.props);
  }

  @bind
  onBack() {
    let { selected } = this.props;
    this.props.onNavigate(selected.substring(0, selected.lastIndexOf('.')));
  }
}

export default QuickPickRaw;

export const { defaultProps } = QuickPickRaw;
